import {Outlet} from 'react-router-dom';
import {useAuthentication} from '@common/hooks/auth/useAuthentication';

const AuthGuard = () => {
  const isAuthenticated = useAuthentication();

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
};

export default AuthGuard;
